import type React from 'react';

import { Grid, IconButton, Link } from '@mui/material/';
import { Trans } from 'react-i18next';

import AlertIcon from 'assets/icons/icn _ 24px _ alert.svg?react';
import { useStyles } from 'components/dialogs/sendMessageDialog/style';
import { BodyLarge } from 'components/typography/Typography';
import { getEnvConfig } from 'config/environment';

const SendMessageSafePlayWarning: React.FC = () => {
  const { classes } = useStyles();

  return (
    <Grid item className={classes.warningContainer} id="send-message-safe-play-warning">
      <Grid item className={classes.warningWrapper}>
        <IconButton className={classes.warningIcon} size="large">
          <AlertIcon />
        </IconButton>
        <BodyLarge className={classes.warningText}>
          <Trans
            components={{
              Link: (
                <Link href={getEnvConfig().REACT_APP_SEND_SMS_NOTE_SFP_ADULT_URL} target="_blank" underline="hover" />
              ),
            }}
            i18nKey="sendSMSDialogNoteUnder17"
          />
        </BodyLarge>
      </Grid>
    </Grid>
  );
};

export default SendMessageSafePlayWarning;
